import classNames from 'classnames'
import React from 'react'
import { PortableTextBodyElement } from '../../utilities/blockContent'
import { isNullOrWhiteSpace } from '../../utilities/string'
import { Image, ImageProps } from '../Image'
import { SignupForm } from '../SignupForm/SignupForm'

export interface NewsletterFormProps {
  description: string
  disclaimer?: PortableTextBodyElement[]
  heading?: string
  image?: ImageProps
  additionalClassName?: string
}

export const NewsletterForm = ({
  image,
  description,
  disclaimer,
  heading,
  additionalClassName,
}: NewsletterFormProps): JSX.Element => (
  <div
    className={classNames(
      'flex flex-col items-center w-full bg-primary',
      additionalClassName
    )}
  >
    <div
      className={classNames(
        'flex flex-col w-full',
        'sm:flex-row sm:flex-wrap sm:max-w-[78.75rem]'
      )}
    >
      {image && (
        <div className={classNames('w-full relative', 'sm:w-1/2')}>
          <Image
            {...image}
            applyLqip
            className="w-full h-full"
            pictureClassName="w-full sm:w-auto sm:h-full sm:absolute sm:min-w-full object-cover"
            imgClassName="w-full sm:h-full object-cover"
            loading="lazy"
          />
        </div>
      )}

      <div className={classNames('w-full relative', 'sm:w-1/2')}>
        <div
          className={classNames(
            'text-white p-30',
            'tb:p-45',
            'sm:pl-80 sm:py-75 sm:pr-90'
          )}
        >
          {(!isNullOrWhiteSpace(heading) || !isNullOrWhiteSpace(description)) && (
            <div className="mb-30 flex flex-col gap-15 sm:gap-30">
              {!isNullOrWhiteSpace(heading) && (
                <h2 className="font-h2 text-h2">{heading}</h2>
              )}
              {!isNullOrWhiteSpace(description) && (
                <p className="font-body text-body">{description}</p>
              )}
            </div>
          )}

          <SignupForm
            disclaimer={disclaimer}
            theme={{
              theme: 'dark',
              textColor: 'text-white',
              textSize: 'text-t-300 tb:text-t-400',
              radioCheckBoxAlignment: 'flex-col sm:flex-row',
              countryAndInvestorAsColumn: true,
            }}
          />
        </div>
      </div>
    </div>
  </div>
)
